<div>
      <group-list [canAll]="true" ></group-list>
</div>
  